import React, { lazy, Suspense } from "react";
import Grid from "@material-ui/core/Grid";
import Skeleton from '@material-ui/lab/Skeleton';


import RoomBg from "../../images/rooms-bg.png";
import Banner from "../Banner/Banner";
import ResortMenu from "../Resort/ResortMenu";
import ResortGrid from "../Resort/ResortGrid";
import RoomGrid from "../Room/RoomGrid";
import styles from "./styles";
import useGlobal from "../../store";

const Booking = lazy(() => import('../Booking/Booking.jsx'));

export default function Resort(props) {
	const classes = styles();
	const [globalState, globalActions] = useGlobal();
	const { getResort } = globalActions.resortContext;
	const { resort } = globalState.resortContext;
	const renderLoader = () => <Skeleton animation="wave" variant="rect" height={570} width={275} />;

	React.useEffect(() => {
        getResort(props.match.params.slug);
	}, []);

    React.useEffect(() => {
        getResort(props.match.params.slug);
	}, [props.match.params.slug]);

	return (
        <>
        {resort && 
        <div>
			<div className={classes.bannerwrapper}>
                <ResortMenu resort={resort} />
				<div className={classes.bwrapper}>
                    <Suspense fallback={renderLoader()}>
                        <Booking />
                    </Suspense>
                    {resort && 
                        <Banner resort={resort} type={'resort'} />
                    }
				</div>
				<span className={classes.leafwrapper}></span>
				<div className="clear"></div>
			</div>
			<div className={"contentsWrap"}>
				<section className="aboutContent">
					<div className="playfair h1">
						{resort.name} Hotels & Resorts
					</div>
					<p>{resort.short_description}</p>
				</section>
				<section>
					<div className={classes.rooms}>
						<div className={"left"}>
							<img src={RoomBg} alt="" />
							<div className={"roomBg"}>
								<div className={"roomOutline"}>
									<div className={"roomHeader"}>
										<span>The Grove</span>
										<span>Recommends</span>
									</div>
									<p>
                                    {resort.description}
									</p>
								</div>
							</div>
						</div>
						<div className={"right"}>
							{resort.rooms && resort.rooms.length && (
								<div className={"grid"}>
									{resort.rooms.map((room, key) => (
										<RoomGrid key={key} room={room} resort={resort} />
									))}
								</div>
							)}
						</div>
					</div>
				</section>
			</div>
			<div className={classes.activitiesWrapper}>
				<Grid container spacing={24}>
					{resort.grids && resort.grids.length &&
                        resort.grids.map((grid, key) => (
							<ResortGrid key={key} index={key} grid={grid} />
						))
					}
				</Grid>
			</div>
		</div> 
        }
        </>
	);
}
